import {
  pushTosPrivacyConsentGiven,
  TosPrivacyConsentScreenType,
} from '@paybis/frontend-common-lib/src/services/gtm';

import ModalPopUp from '../helpers/modal';
import { acceptTermsOfService, clearUserCache } from '../services/terms';
import {
  PHP_LAYOUT_TOS_POPUP_ACCEPT_BUTTON_ID,
  PHP_LAYOUT_TOS_POPUP_ERROR_ELEMENT_ID,
  PHP_LAYOUT_TOS_POPUP_MODAL_ID,
} from './phpLayoutTermsOfServicePopup.constants';

export function initPhpLayoutTermsOfServicePopup(): void {
  let isAcceptInProgress = false;

  const onAcceptTermsOfService = async () => {
    if (isAcceptInProgress) {
      return;
    }
    isAcceptInProgress = true;

    const errorMessage = document.getElementById(PHP_LAYOUT_TOS_POPUP_ERROR_ELEMENT_ID);
    if (errorMessage !== null) {
      errorMessage.style.display = 'none';
    }

    pushTosPrivacyConsentGiven(TosPrivacyConsentScreenType.MEMBER_AREA);

    try {
      await acceptTermsOfService();
      await clearUserCache();
      ModalPopUp.closeModal(PHP_LAYOUT_TOS_POPUP_MODAL_ID);
    } catch {
      if (errorMessage !== null) {
        errorMessage.style.display = 'block';
      }
    } finally {
      isAcceptInProgress = false;
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    const acceptButton = document.getElementById(PHP_LAYOUT_TOS_POPUP_ACCEPT_BUTTON_ID);
    if (acceptButton === null) {
      return;
    }
    acceptButton.addEventListener('click', onAcceptTermsOfService);
  });
}
